import Axios from '../../../networking/intraceptor';
import {
	pharmacy_pharmacist_verification,
	pharmacy_pharmacist_verification_context,
} from '../../../networking/urlEndPoints';

export const fetchPharmacistVerificationContext = async () => {
	return Axios.get(pharmacy_pharmacist_verification_context);
};

export const savePharmacistVerification = async ({ cpsid, rxcollege }) => {
	return Axios.post(pharmacy_pharmacist_verification, {
		cpsid,
		rxcollege,
	});
};
